import { FormattedMessage } from 'react-intl';
import { Tag } from '@ets/design-system';
import { useDispatch } from '_common/hooks';

import { openAndUpdateModal } from '_common/modals/ModalsSlice';

type OptionsProps = {
  field: Affiliation.Field;
  option: Affiliation.Value[number];
  testId: string;
};

const Option = ({ field, option, testId }: OptionsProps) => {
  const dispatch = useDispatch();

  const editOption = () => {
    dispatch(
      openAndUpdateModal({
        modal: 'AddAffiliationModal',
        data: {
          operation: 'edit',
          field,
          option,
        },
      }),
    );
  };

  const deleteOption = () => {
    dispatch(
      openAndUpdateModal({
        modal: 'ConfirmationModal',
        data: {
          title: 'DELETE_SOMETHING_QUOTED',
          titleValues: { label: option },
          message: 'DELETING_THIS_AFFILIATION_FIELD_OPTION_WILL_REMOVE_CONFIRM',
          confirmButtonTextId: 'global.delete',
          cancelButtonTextId: 'global.cancel',
          confirmButtonType: 'danger',
          actionCode: 'deleteFieldOption',
          width: '60rem',
          actionValue: { field, value: option },
          cancelButtonShow: true,
        },
      }),
    );
  };
  return (
    <Tag
      size="m"
      label={option}
      variant="neutral"
      style={{ margin: '0 1rem 1rem 0' }}
      icon="ellipsis"
      dropdownItems={[
        {
          onClick: editOption,
          children: <FormattedMessage id="global.edit" />,
          testId: 'edit-item',
        },
        {
          onClick: deleteOption,
          children: <FormattedMessage id="global.delete" />,
          testId: 'delete-item',
        },
      ]}
      testId={testId}
    ></Tag>
  );
};

export default Option;
